module.exports = __webpack_public_path__ + "img/red-stop-lamp-error.744fbb7a.svg";